export const AUTH_ENDPOINTS = {
  login: "admin/admin-login/",
  refresh: "/users/refresh/",
  logout: "users/logout/",
};

export const AUTH_PUBLIC_API_ROUTES = [
  "/login",
  "/refresh",
  "/users/forget-password/",
  "/users/forget-password-otp-verify/",
  "/users/reset-password/",
];

export const AUTH_PUBLIC_APP_ROUTES = [
  "/login",
  "/forgot-password",
  "/forgot-password/verify",
  "/change-password",
];
